export default __webpack_public_path__ + "static/media/GT-Walsheim-Regular.c4f8cd15.woff2";